{
  "paymentMethodUnavailable": "无法使用这个付款方式",
  "serverError": "服务器异常，请稍候重试。",
  "tradeRecommendation": "交易推荐",
  "tradeRecommendationDescription": "目前未找到符合您金额需求的订单，但有推荐的金额可供选择，是否考虑以推荐的金额进行交易？",
  "tradeWithRecommendation": "好，以推荐金额交易",
  "listOriginalAmount": "不，使用原金额挂单",
  "selectPaymentMethod": "请选择付款方式",
  "selectReceivingMethod": "请选择收款方式",
  "fastTradingUnavailable": "极速交易暂时不可用，请稍候重试。",
  "paymentAmountLimitExceeded": "超过支付金额上限",
  "securityReminder": "提醒：{{token}}只有在线客服联系方式，不会电话支付宝微信联系用户！",
  "buyToken": "购买{{token}}",
  "sellToken": "出售{{token}}",
  "selectTradingMethod": "选择交易方式",
  "paymentMethodsUnavailable": "支付方式暂时不可用",
  "unavailableMethodRetry": "{{methods}}刚刚无法处理这笔付款。带红点的方式仍可点击重试，您也可以选择其他付款方式。",
  "unavailableMethodChooseOther": "{{methods}}刚刚无法处理这笔付款。请选择其他付款方式。",
  "vipFastPayEligibility": "当前为 VIP {{level}}，以下{{methodType}}方式符合您的极速交易条件。",
  "continueStandardC2C": "继续普通C2C",
  "methodUnavailableRetry": "{{method}}，暂时不可用，可以重试",
  "unavailableRetry": "暂时不可用，可重试",
  "selectThisMethod": "选择此方式",
  "vipAvailability": "VIP可用范围",
  "fee": "手续费",
  "expectedCredit": "预计到账",
  "fastPayCollectionInformation": "极速交易收款信息",
  "scanToPay": "请使用{{method}}扫描二维码完成付款。",
  "payUsingInformation": "请按以下信息完成付款。",
  "receivingQrCode": "{{method}}收款二维码",
  "orderNumber": "订单号",
  "receivingName": "收款姓名",
  "receivingAccount": "收款账号",
  "amountDue": "应付金额",
  "transactionChannel": "交易渠道",
  "paymentDeadline": "支付截止时间",
  "notice": "提示",
  "payExactAmount": "请严格按照应付金额付款",
  "close": "关闭",
  "kycRequired": "请先进行身份认证",
  "kycRequiredDescription": "请先进行身份认证以继续使用当前交易方式。",
  "gotIt": "我知道了",
  "goToKyc": "去认证",
  "cannotStartTrade": "无法开启新交易",
  "buyOrderInProgress": "有进行中的买币订单，交易结束后才能开启新的买币交易。",
  "minimumTransactionRequired": "请输入单笔最低成交",
  "minimumLessThanListed": "必须小于挂单总数量",
  "insufficientBalance": "余额不足以挂单",
  "listedQuantityLimitExceeded": "超过挂单总数量上限",
  "availableBalance": "可用余额：",
  "selectedReceivingMethods": "已选择{{count}}个收款方式",
  "fastSell": "极速交易出售",
  "fastSellSubmitted": "出售请求已提交，到账结果将以系统状态为准。",
  "fastSellFailed": "出售请求未成功，请稍候重试或使用普通C2C。",
  "providerOrderNumber": "通道订单号",
  "providerFee": "通道手续费",
  "status": "状态",
  "remark": "备注",
  "minimumTransactionHint": "买方必须至少购买的数量。",
  "fastPayDetails": "极速交易详情",
  "orderStatus": "订单状态",
  "closedAt": "关闭时间",
  "amountInformation": "金额信息",
  "creditedQuantity": "到账数量"
}
